import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { MultiplePaymentResponseDTO, PaymentDetail } from '../../../types/sale/payment/MultiplePaymentTypes';

// Tipo para métodos de pago
export interface PaymentMethod {
  id: number;
  name: string;
  code: string;
}

interface MultiplePaymentState {
  payments: PaymentDetail[];
  totalToPay: number;
  totalEntered: number;
  pendingAmount: number;
  isLoading: boolean;
  paymentMethods: PaymentMethod[];
}

const initialState: MultiplePaymentState = {
  payments: [],
  totalToPay: 0,
  totalEntered: 0,
  pendingAmount: 0,
  isLoading: false,
  paymentMethods: [],
};

const multiplePaymentSlice = createSlice({
  name: 'multiplePayment',
  initialState,
  reducers: {

    /**
     * 🔥 SET GLOBAL STATE DESDE BACKEND
     * (Única fuente de verdad)
     */
    setMultiplePayments(state, action: PayloadAction<MultiplePaymentResponseDTO>) {
      state.payments = action.payload.payments;
      state.totalToPay = action.payload.totalToPay;
      state.totalEntered = action.payload.totalEntered;
      state.pendingAmount = action.payload.pendingAmount;
    },

    /**
     * ⏳ Loading
     */
    setIsLoadingPayments(state, action: PayloadAction<boolean>) {
      state.isLoading = action.payload;
    },

    /**
     * 💳 Métodos de pago
     */
    setPaymentMethods(state, action: PayloadAction<PaymentMethod[]>) {
      state.paymentMethods = action.payload;
    },

    /**
     * 🧹 Reset completo
     */
    clearMultiplePayments(state) {
      state.payments = [];
      state.totalToPay = 0;
      state.totalEntered = 0;
      state.pendingAmount = 0;
    }
  }
});

export const {
  setMultiplePayments,
  setIsLoadingPayments,
  setPaymentMethods,
  clearMultiplePayments,
} = multiplePaymentSlice.actions;

export default multiplePaymentSlice.reducer;